import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ZealApiResponse } from "@zeal/common";
import {
  TCreateLaborPosterRequestSchema,
  TCreateLaborPosterResponseSchema,
} from "./createLaborPoster.schema";

const LABOR_POSTER_UPLOAD_TIMEOUT_MS = 180000;

export const createLaborPoster = (axios: IAxiosInstance) => {
  return async (
    data: TCreateLaborPosterRequestSchema
  ): Promise<ZealApiResponse<TCreateLaborPosterResponseSchema>> => {
    const formData = new FormData();
    Object.entries(data).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        if (value instanceof File) {
          formData.append(key, value);
        } else {
          formData.append(key, String(value));
        }
      }
    });
    const response = await axios.noRetry.post<
      ZealApiResponse<TCreateLaborPosterResponseSchema>
    >("/labor-posters", formData, {
      headers: { "Content-Type": "multipart/form-data" },
      timeout: LABOR_POSTER_UPLOAD_TIMEOUT_MS,
    });
    return response.data;
  };
};
